export const colors = {
    navy: "#211C6A",
    pastel: "#FFDEDE",
    lemon: "#F1D18A",
    apple: "#F83759",
    smooth: "#F696A7",
    spotify: "#1ED760",
    black: "#121212",
    silver: "#EDEDED",

    brown: "#B2533E",
    yellow: "#FCE09E",
    yeondu: "#B5CB99",
    teal: "#186F65",

    white: "#FFFFFF",
    blue: "#002060",
    gray: "#BFC2C8",
    light: "#E9F0FF",
    dark: "#20293B",
    green: "#29CB00",
    link: "#FF7919",
    red: "#F40009",
    cola: "#5E3023",
    bubble: "#A9746E",
    new: "#FFE6D4",
    covalt: "#1A73E9",
    g1: "#262626",
    g2: "#666666",
    g3: "#BFBFBF",
    g4: "#D9D9D9",
    g5: "#F4F4F4"
}